import Api from './api';

const homePageContactFormRequest = (data) => {
    return Api().post('/api/contact', data)
}


export default {
    homePageContactFormRequest,
}



// WEBPACK FOOTER //
// ./src/api/apiForms.js